

























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ResponsiveSizes, ComponentModel, ContentModel } from '@/models';

@Component
export default class ContentCss extends Vue {
  @Prop()
  size!: ResponsiveSizes;

  @Prop()
  model!: ComponentModel;

  get contentCss() {
    if (
      !this.model ||
      (this.model.typeName !== 'Grid' && this.model.typeName !== 'Column')
    )
      return undefined;
    return this.model.getCss<ContentModel>('content', this.size);
  }

  get flexCssValue() {
    if (
      !this.model ||
      (this.model.typeName !== 'Grid' && this.model.typeName !== 'Column')
    )
      return undefined;
    return this.model.getCss<ContentModel>('content', ResponsiveSizes.All);
  }
}
